import { observer } from "mobx-react-lite";
import { useDriveTimeStore } from "../..";
import IGeoCoordinate from "../../interfaces/IGeoCoordinate";
import { DriveTimeMinutes } from "../../store/DriveTimeStore";
import commonStyles from "../Common.module.css";
import FieldRow from "../FieldRow";
import Spinner from "../spinners/Spinner";

function PropertyIndustrialScarcityRow({ centerPoint }: IPropertyIndustrialScarcityRowProps) {
    const driveTimeStore = useDriveTimeStore();
    const percent = driveTimeStore.getIndustrialScarcityPercent(centerPoint, DriveTimeMinutes._45);
    const isLoading = driveTimeStore.getIsIndustrialScarcityLoading(centerPoint, DriveTimeMinutes._45);
    const calculate = () => driveTimeStore.fetchIndustrialScarcityPercent(centerPoint, DriveTimeMinutes._45);

    return (
        <FieldRow label="45 MIN INDUSTRIAL SCARCITY">
            {isLoading && <Spinner />}
            {!isLoading && percent != null && `${percent.toFixed(1)}%`}
            {!isLoading && percent == null && <span className={commonStyles.link} onClick={calculate}>Calculate</span>}
        </FieldRow>
    );
}

export default observer(PropertyIndustrialScarcityRow);

interface IPropertyIndustrialScarcityRowProps {
    centerPoint: IGeoCoordinate;
}
